import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className={`dark-header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="logo-container" onClick={() => scrollToSection('hero')}>
        <span className="logo-text">Unique</span>
        <span className="logo-accent">Creative</span>
      </div>

      <nav className="dark-nav desktop-nav">
        <button onClick={() => scrollToSection('hero')} className="dark-nav-link">
          Domů
        </button>
        <button onClick={() => scrollToSection('about')} className="dark-nav-link">
          O nás
        </button>
        <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
          Kontakt
        </button>
      </nav>

      <button 
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('hero')} className="dark-nav-link">
            Domů
          </button>
          <button onClick={() => scrollToSection('about')} className="dark-nav-link">
            O nás
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
            Kontakt
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
